
class RpcApiWrapper {
  constructor (store) {
    this.store = store
  }

  static install (store) {
    let rpcApiWrapper = new RpcApiWrapper(store)
    if (typeof window !== 'undefined' && window.Vue) {
      window.Vue.prototype.$rpcApiWrapper = rpcApiWrapper
      window.Vue.$rpcApiWrapper = rpcApiWrapper
    }
  }

  async getVipCardInfo () {
    try {
      let config = await this.store.dispatch('getConfig')
      let api = window.Vue.$apiUtil.getMisBuyerApi()
      let data = await api.getCard(config.vip_cardid)
      return data.card
    } catch (error) {
      throw error
    }
  }

  async getCompanyCardInfo () {
    try {
      let config = await this.store.dispatch('getConfig')
      let api = window.Vue.$apiUtil.getMisBuyerApi()
      let data = await api.getCompanyCard(config.company_cardid)
      return data.card
    } catch (error) {
      throw error
    }
  }
}

export default RpcApiWrapper



// WEBPACK FOOTER //
// ./src/apis/rpcApiWrapper.js